<loading [loading]="loading.isShow" [loadingMessage]="loading.message"></loading>

<div [hidden]="loading.isShow">
  <ng-container *ngIf="error_messages.length > 0">
    <ng-container *ngFor="let error_message of error_messages">
      <div class="alert alert-danger">
        <button type="button" class="close" data-dismiss="alert" (click)="removeErrorMessage(error_message)">
          ×
        </button>
        {{ error_message }}
      </div>
    </ng-container>
  </ng-container>

  <div [hidden]="!login">
    <div class="loginmodal-container">
      <h1>Log in to your signNow account</h1>
      <br />
      <form>
        <input type="text" name="user" class="sn-sf-input" placeholder="Email" #emailInput />
        <input type="password" name="pass" class="sn-sf-input" placeholder="Password" #passwordInput />
        <div class="loginmodal-container__controls">
          <button
            class="btn btn-primary full-width"
            (click)="login_user(emailInput.value, passwordInput.value)"
          >
            Login
          </button>
          <sn-sso-login-btn (loginEvent)="reloadAfterSSOLogin()"></sn-sso-login-btn>
          <div class="tac create-account">
            <span>No account?&nbsp;</span>
            <a
              class="create-account__link"
              href="https://snseats.signnow.com/purchase/business_free_trial/loggedout?source=salesforce"
              target="_blank"
            >
              Sign up for signNow for free
            </a>
          </div>
        </div>
      </form>
    </div>
  </div>

  <div [hidden]="login">
    <button class="btn btn-primary log-out-btn" (click)="logout_user()">Logout</button>

    <div
      role="dialog"
      tabindex="-1"
      class="slds-modal_large"
      aria-labelledby="id-of-modalheader-h2"
      aria-describedby="modal-content-id-1"
    >
      <div class="slds-modal__container">
        <header class="slds-modal__header">
          <h2 id="id-of-modalheader-h2" class="slds-text-heading_medium">Records</h2>
        </header>
        <div class="slds-modal__content slds-p-around_medium" id="modal-content-id-1">
          <div class="row">
            <div class="col-md records-container">
              <div class="panel panel-default panel-table">
                <div class="panel-heading">
                  <div class="row">
                    <div class="col">
                      <div id="query-builder" class="builder-wrap">
                        <sn-query-builder
                          class="query-builder"
                          [conditionLimit]="7"
                          [sfObjectFields]="recordFieldsMeta"
                          (conditionsE)="loadFilteredRecordsList($event)"
                        ></sn-query-builder>
                      </div>
                    </div>
                  </div>
                  <br />
                  <div class="row">
                    <div class="col">
                      <input
                        type="text"
                        (keyup)="search_records(search.value)"
                        class="sn-sf-input"
                        placeholder="Search this list..."
                        #search
                      />
                      <span class="glyphicon glyphicon-search search-icon"></span>
                      <button
                        type="button"
                        class="btn btn-primary floating_button_left"
                        (click)="open_modal()"
                      >
                        Upload CSV
                      </button>
                      <ng-container *ngIf="is_view_next">
                        <button
                          type="button"
                          (click)="go_to_template_list()"
                          class="btn btn-primary floating_button"
                        >
                          Next
                        </button>
                      </ng-container>
                      <!--<input type="file" (change)="readFile($event)" class="form-control-file floating_button" />-->
                      <!--<div class="custom-file csv-input-div">
                        <input type="file" (change)="readFile($event)" class="custom-file-input">
                        <label class="custom-file-label" for="customFile">Upload CSV</label>
                      </div>-->

                      <!-- Modal
                      <div class="modal fade" id="uploadModal" role="dialog">
                        <div class="modal-dialog">


                          <div class="modal-content">
                            <div class="modal-header">
                              <button type="button" class="close" data-dismiss="modal">&times;</button>
                              <h4 class="modal-title">Upload CSV</h4>
                            </div>
                            <div class="modal-body">

                            </div>
                            <div class="modal-footer">
                              <button type="button" class="btn btn-neutral" data-dismiss="modal">Close</button>
                            </div>
                          </div>

                        </div>
                      </div>-->
                    </div>
                  </div>
                </div>
                <div class="panel-body">
                  <table
                    class="table table-bordered table-list"
                    id="RecordTable"
                    #RecordTable
                    *ngIf="records.length; else emptyList"
                  >
                    <thead>
                      <tr>
                        <th class="checkboxes-column">
                          <input
                            type="checkbox"
                            class="slds-checkbox"
                            (change)="checkItem($event)"
                            [(ngModel)]="isChecked"
                          />
                        </th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Created Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      <ng-container *ngFor="let record of records">
                        <tr>
                          <td style="text-align: center">
                            <input
                              type="checkbox"
                              class="slds-checkbox"
                              [checked]="record.selected"
                              (change)="addToRecordList(record, $event)"
                            />
                          </td>
                          <td><span class="glyphicon glyphicon-file"></span>&nbsp;&nbsp;{{ record.Name }}</td>
                          <td class="created_column">{{ record.Email }}</td>
                          <td class="created_column">{{ record.CreatedDate }}</td>
                        </tr>
                      </ng-container>
                    </tbody>
                  </table>

                  <ng-template #emptyList>
                    <div class="empty-list">No any record for now.</div>
                  </ng-template>
                </div>
                <div class="panel-footer tac">
                  <!-- pager -->
                  <ul *ngIf="pager.totalPages && records.length" class="pagination">
                    <li [ngClass]="{ disabled: pager.currentPage === 1 }">
                      <a (click)="setPage(1)">First</a>
                    </li>
                    <li [ngClass]="{ disabled: pager.currentPage === 1 }">
                      <a (click)="setPage(pager.currentPage - 1)">Previous</a>
                    </li>
                    <!--<li *ngFor="let page of pager.pages" [ngClass]="{active:pager.currentPage === page}">-->
                    <!--<a (click)="setPage(page)">{{page}}</a>-->
                    <!--</li>-->
                    <li>
                      <a class="pagination__total"
                        >[{{ (pager.currentPage - 1) * recordsloadLimit + 1 }} -
                        {{ (pager.currentPage - 1) * recordsloadLimit + records.length }} of
                        {{ recordsTotal }}]</a
                      >
                    </li>
                    <li [ngClass]="{ disabled: pager.currentPage === pager.totalPages }">
                      <a (click)="setPage(pager.currentPage + 1)">Next</a>
                    </li>
                    <li [ngClass]="{ disabled: pager.currentPage === pager.totalPages }">
                      <a (click)="setPage(pager.totalPages)">Last</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<sn-modal-popup [isShowModal]="uploadCSVModal">
  <ng-container class="sn-modal-header">
    <h2 id="modal-heading-01" class="slds-text-heading_medium slds-hyphenate">
      Upload Record ID List in CSV Format
    </h2>
  </ng-container>
  <ng-container class="sn-modal-content">
    <div class="file-upload" style="max-width: 320px; margin: auto">
      <div class="slds-form-element">
        <div class="slds-form-element__control">
          <div class="slds-file-selector slds-file-selector_images">
            <div class="slds-file-selector__dropzone">
              <input
                type="file"
                class="slds-file-selector__input slds-assistive-text"
                id="file-upload-input-01"
                (change)="readFile($event)"
                data-dismiss="modal"
              />
              <label
                class="slds-file-selector__body"
                for="file-upload-input-01"
                id="file-selector-secondary-label"
              >
                <span class="slds-file-selector__button btn btn-neutral">
                  <span class="glyphicon glyphicon-upload"></span>
                  Upload CSV
                </span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container class="sn-modal-footer">
    <button (click)="close_modal()" class="btn btn-neutral">Cancel</button>
  </ng-container>
</sn-modal-popup>
